import request from "@/utils/request";
const projectName = "/api/blade-platform";
export const personalPresetTotalList = params => {
    return request({
        url: `${projectName}/presetService/personalPresetTotalList`,
        method: "post",
        data: params
    });
};
export const list = params => {
    return request({
        url: `${projectName}/presetService/personalPreset/list`,
        method: "post",
        data: params
    });
};
export const add_list = params => {
    return request({
        url: `${projectName}/presetService/getPersonalPreset/list`,
        method: "post",
        data: params
    });
};
export const save = params => {
    return request({
        url: `${projectName}/presetService/personalService/save`,
        method: "post",
        data: params
    });
};
export const remove = params => {
    return request({
        url: `${projectName}/presetService/personalService/remove`,
        method: "post",
        data: params
    });
};
export const changeSort = params => {
    return request({
        url: `${projectName}/presetService/changeSort`,
        method: "post",
        data: params
    });
};
